module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-01-6a4577c344c5405687ef559b62ae6803.svg";